import { useState } from "react";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebase/config";
import { useAuth } from "../../contexts/AuthContext";
import PhotoUpload from "../ui/PhotoUpload";
import { toDatetimeLocal } from "../../utils/dateUtils";

const JournalEntryForm = ({ childId, onAdded }) => {
  const { user } = useAuth();
  const [text,     setText]     = useState("");
  const [date,     setDate]     = useState(() => toDatetimeLocal());
  const [photoURL, setPhotoURL] = useState(null);
  const [saving,   setSaving]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim() && !photoURL) return;
    setSaving(true);
    try {
      await addDoc(collection(db, "journalEntries"), {
        childId,
        userId:    user.uid,
        date:      new Date(date).toISOString(),
        text:      text.trim(),
        photoURL:  photoURL || null,
        createdAt: new Date().toISOString(),
      });
      setText("");
      setDate(toDatetimeLocal());
      setPhotoURL(null);
      onAdded?.();
    } catch (err) {
      console.error("Error saving journal entry:", err);
      alert("Failed to save entry.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        background: "linear-gradient(135deg, rgba(255,179,217,0.06) 0%, rgba(179,229,252,0.06) 100%)",
        borderRadius: "12px",
        padding: "1rem 1.25rem",
        marginBottom: "1.5rem",
        border: "1.5px solid var(--border-light)",
      }}
    >
      <div className="row g-2 mb-2">
        <div className="col-md-4">
          <label className="form-label" style={{ fontSize: "0.82rem" }}>Date &amp; Time</label>
          <input
            type="datetime-local"
            className="form-control form-control-sm"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>
      </div>

      <div className="mb-2">
        <textarea
          className="form-control"
          rows={3}
          placeholder="Write a memory, note, or update…"
          value={text}
          onChange={(e) => setText(e.target.value)}
          style={{ resize: "vertical", fontSize: "0.95rem" }}
        />
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
        <PhotoUpload childId={childId} onUpload={setPhotoURL} disabled={saving} value={photoURL} />
        <button
          type="submit"
          className="btn btn-primary btn-sm"
          disabled={saving || (!text.trim() && !photoURL)}
        >
          {saving ? "Saving…" : "✏ Add to Journal"}
        </button>
      </div>
    </form>
  );
};

export default JournalEntryForm;
